import React from 'react';
import { FlexRow } from '../../../../common/components/v2';
import { Resource } from '../../../../common/constants/resource';
import { MVRApplicant } from '../../../tasks/types/mvr';
import styles from '../../styles.module.scss';
import { dateToString } from '../../utilities/formattingUtilities';
import { TaskDetailsItem } from '../components/TaskDetailsItem';

export const RenderApplicantSection = (applicant: MVRApplicant) => {
  return (
    <>
      <FlexRow className={styles.TaskSubtitle}>
        {Resource.MVR_APPLICANT_SUBTITLE}
      </FlexRow>
      <TaskDetailsItem
        leftItem={Resource.MVR_APPLICANT_NAME}
        rightItem={applicant.name}
      />
      <TaskDetailsItem
        leftItem={Resource.MVR_APPLICANT_BIRTH_DATE}
        rightItem={dateToString(applicant.dob)}
      />
      <TaskDetailsItem
        leftItem={Resource.MVR_APPLICANT_ADDRESS}
        rightItem={applicant.address}
      />
    </>
  );
};
